import { render, staticRenderFns } from "./lotteryAutoRiskCtrl.vue?vue&type=template&id=17131dca&scoped=true"
import script from "./lotteryAutoRiskCtrl.vue?vue&type=script&lang=js"
export * from "./lotteryAutoRiskCtrl.vue?vue&type=script&lang=js"
import style0 from "./lotteryAutoRiskCtrl.vue?vue&type=style&index=0&id=17131dca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17131dca",
  null
  
)

export default component.exports